import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

/** One obligation (filing) in the content list, deduped to one row per compositeId. */
export interface ObligationSummary {
  compositeId: string;
  displayName: string;
  formNumber: string | null;
  obligationCategory: string;
  jurisdiction: string | null;
  country: string;
}

export interface GetObligationsResponse {
  obligations: ObligationSummary[];
  count: number;
}

/** The obligation content list with all filters in one call. Gated on a country (no request until one is
 * chosen), mirroring useGetFilingCategories. */
export function useGetObligations(
  params?: {
    country?: string;
    jurisdiction?: string;
    category?: string;
    search?: string;
  },
  token?: string
) {
  const query = new URLSearchParams();
  if (params?.country) query.append('country', params.country);
  if (params?.jurisdiction) query.append('jurisdiction', params.jurisdiction);
  if (params?.category) query.append('category', params.category);
  if (params?.search) query.append('search', params.search);
  const queryString = query.toString();
  const url = params?.country
    ? `content/obligations${queryString ? `?${queryString}` : ''}`
    : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: GetObligationsResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(url, SWRFetcher({ method: 'GET' }, token));

  return {
    data,
    error,
    mutate,
    isLoading: Boolean(url) && !data && !error,
  };
}
